export const PRODUCT_COLLECTION_PRICING_GET_REQUEST = 'PRODUCT_COLLECTION_GET_REQUEST';
export const PRODUCT_COLLECTION_PRICING_GET_SUCCESS = 'PRODUCT_COLLECTION_PRICING_GET_SUCCESS';
